function formatPKR(amount) {
  if (!amount || isNaN(amount)) return "0";

  const absAmount = Math.abs(amount);

  if (absAmount >= 10000000) {
    // Crore
    return `${Number((amount / 10000000).toFixed(2))} crore`;
  }

  if (absAmount >= 100000) {
    // Lac
    return `${Number((amount / 100000).toFixed(2))} lakh`;
  }

  if (absAmount >= 1000) {
    // Thousand
    return `${Number((amount / 1000).toFixed(2))} thousand`;
  }

  return amount.toString();
}
export default formatPKR